

import Link from 'next/link';
import Image from "next/image";

const Footer = () => {
  // const goToBtn = () => {
  // 	window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  // };

  return (
    <div className="bg-greenBg lg:px-[84px] px-4 pt-[51px] text-white">
      <div className="grid grid-cols-3 lg:grid-cols-4 lg:justify-between gap-8 lg:gap-0">
        <div>
          <Image
            src={"/images/PRIMARY-LOGO-V3.png"}
            height={41}
            width={170}
            alt="footerImage"
            className='-ml-4 lg:-ml-0'
          />
          <p className="text-[14px] text-[#fff] font-medium leading-normal mt-[23px]">
             SERPtag | Rank Better, Grow Faster.
          </p>
        </div>
        <div>
        <div className="text-[18px] leading-normal text-white mb-[18px] font-bold">
  Get socials
</div>
          <div className="flex flex-col gap-0.01">
            <a href="https://twitter.com/serptag" target="_blank" rel="noopener noreferrer" 
               className="text-[18px] font-normal leading-none mb-[14px]">
              Twitter
            </a>
            <a href="https://www.linkedin.com/company/serptag" target="_blank" rel="noopener noreferrer" 
               className="text-[18px] font-normal leading-none">
              LinkedIn
            </a>   
          </div>
        </div>
        <div>
  <div className="text-[18px] leading-normal text-white mb-[18px] font-bold">
    Platform
  </div>
  <p className="text-[18px] font-normal leading-none mb-[14px] cursor-pointer">
  <Link href="/rank-tracker" className="cursor-pointer">
  Rank Tracker
</Link>
  </p>
  <p className="text-[18px] font-normal leading-none mb-[14px] cursor-pointer">
    <Link href="/keyword-research" className="cursor-pointer"> 
    Keyword Research
    </Link>
  </p>
  <p className="text-[18px] font-normal leading-none mb-[14px] cursor-pointer">
    <Link href="/ai-analyze" className="cursor-pointer">
    Ai Analyze
    </Link>
  </p>
  <p className="text-[18px] font-normal leading-none mb-[14px] cursor-pointer">
    <Link href="/blogs" className="cursor-pointer"> 
    Blogs
    </Link>
  </p>
</div>

        <div>
  <div className="text-[18px] leading-normal text-white mb-[18px] font-bold">
  Support
  </div>
  <p className="text-[18px] font-normal leading-none mb-[14px] cursor-pointer">
  <Link href="/contact-us" className="cursor-pointer">
    Contact
  </Link>
</p>
</div>
      </div>
      <div className="backGround_class lg:mt-[52px] mx-auto" />
      <div className="flex flex-col lg:flex-row  justify-between py-[20px]">
  <div className="text-[16px] font-normal leading-normal">
    <Link href="/privacy-policy" legacyBehavior>
      <a className="cursor-pointer">Privacy Policy</a>
    </Link>
    {" | "}
    <Link href="/terms-and-conditions" legacyBehavior>
      <a className="cursor-pointer">Terms & Condition</a>
    </Link>
  </div>
        <div className="text-[14px font-normal leading-normal">
          © {new Date().getFullYear()} serptag.com All rights reserved
        </div>
      </div>
    </div>
  );
};

export default Footer;
